import { setActiveOfferId } from './setActiveOfferId';
import { setOffersFetchingMode } from './setOffersFetchingMode';
import { toggleModal } from './toggleModal';
import { EListingModalMode, EOffersFetchingMode } from './types';
import { resetTerms } from '../../../../packages/JsonQuery';
import { TThunkAction } from '../../types/redux';
import { justChangeJsonQuery } from '../filters/justChangeJsonQuery';
import { removeOffers, setPage } from '../listingOffers';

export const closeAndResetListingModal = (): TThunkAction => (dispatch, getState) => {
  const state = getState();
  const { jsonQuery } = state.results;
  const nextJsonQuery = resetTerms(['page'])(jsonQuery);
  const isListingModalOpen = state.listingModal.open;

  if (!isListingModalOpen) {
    return;
  }

  dispatch(toggleModal({ open: false, mode: EListingModalMode.UNSET }));
  dispatch(removeOffers());
  dispatch(setActiveOfferId(null));
  dispatch(justChangeJsonQuery({ nextJsonQuery }));
  dispatch(setPage(1));
  dispatch(setOffersFetchingMode(EOffersFetchingMode.NONE));
};
